export default __webpack_public_path__ + "static/plx_logo-bab7428eed220b5ee287303dd2e54249.png";